module.exports = __webpack_public_path__ + "img/right_highlight.af256e5d.png";